angular.module('impactx.rfxsupplier').controller('RFXSupplierDescriptionCtrl', [
    RFXSupplierDescriptionController
]);

function RFXSupplierDescriptionController() {
    var self = this;

    self.$onInit = function () {
        self.cardExpanded = !self.isClosed;
    };

    self.toggleCardExpansion = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        self.cardExpanded = !self.cardExpanded;
    };
}